import React, { useState } from 'react';
import { Alert, Card, Dropdown } from 'react-bootstrap';
import { customersData } from 'data/ecommerce/customerDetailsData';
import CardDropdown from 'components/common/CardDropdown';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import axios from 'helpers/api';
import { useEffect } from 'react'
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FileManagerGrid = () => {
    const [currentOrder, setCurrentOrder] = useState([]);
    const columns = [
        {
            accessorKey: 'filename',
            header: 'Filename',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'description',
            header: 'Description',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'generic',
            header: 'Download',
            meta: {
                headerProps: { className: 'text-900' }
            },
            cell: ({ row: { original } }) => {
                const imageUrl = original.url;
        
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        {imageUrl ? (
                            <a href={imageUrl}  >
                                <FontAwesomeIcon icon="download" className="fs-16" style={{ cursor: 'pointer' }} />
                            </a>
                        ) : (
                            <span>No image available</span>
                        )}
                    </div>
                );
            }
        }
    ];
    useEffect(() => {

        async function fetchPrescriptionData() {

            let tokenStr = localStorage.getItem("accessToken");
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}`+"/patients/file-manager-list/" + localStorage.getItem("patientId"), { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            let results = []
            let objData = data.data;

            objData.forEach((value) => {
                results.push({
                    filename: value.filename,
                    description: value.tags || '-',
                    url : value.file_url,
                });
            });
            setCurrentOrder(results);
        }

        fetchPrescriptionData();
    }, []);

    const table = useAdvanceTable({
        data: currentOrder,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <>
        {currentOrder.length > 0 ?<AdvanceTableProvider {...table}>
            <AdvanceTable
                headerClassName="bg-200 text-nowrap align-middle text-center"
                rowClassName="text-nowrap align-middle text-center"
                tableProps={{
                    size: 'lg',
                    striped: true,
                    className: 'fs-10 mb-0'
                }}
            />
            <div className="mt-3">
                <AdvanceTableFooter
                    rowInfo
                    navButtons
                    rowsPerPageSelection
                />
            </div>
        </AdvanceTableProvider> : <Alert variant="warning" className="text-center mt-3">
            No data found</Alert>}
        </>
    );
};

export default FileManagerGrid;

